/**
 * @generated SignedSource<<4b5dfdcfe31845bc533bee2ef0026245>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type UserLoginTypeEnum = "AXON" | "ONE_TIME_PASSWORD" | "SSO" | "UNKNOWN" | "%future added value";
export type identityprovidertype = "AXON" | "OIDC" | "SAML" | "UNKNOWN" | "%future added value";
export type login_type = "AXON" | "ONE_TIME_PASSWORD" | "SSO" | "UNKNOWN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type OrgLoginMethods_loginMethods$data = {
  readonly id: string;
  readonly identityProviderConfigurations: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly axonConnectDomain: string | null;
        readonly displayName: string | null;
        readonly id: string;
        readonly name: string;
        readonly oidcCallbackUrl: string | null;
        readonly oidcClientId: string | null;
        readonly oidcInitiateLoginUrl: string | null;
        readonly oidcIssuer: string | null;
        readonly oidcUsePkce: string | null;
        readonly providerType: identityprovidertype;
        readonly samlAcsUrl: string | null;
        readonly samlMetadataUrl: string | null;
        readonly uuid: string;
      } | null;
    } | null>;
  } | null;
  readonly loginOverrideCounts: ReadonlyArray<{
    readonly count: number;
    readonly displayName: string;
    readonly key: string;
    readonly loginType: UserLoginTypeEnum;
  } | null> | null;
  readonly loginTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly authEnabled: boolean;
        readonly identityProviderConfiguration: {
          readonly axonConnectDomain: string | null;
          readonly id: string;
          readonly name: string;
          readonly oidcCallbackUrl: string | null;
          readonly oidcClientId: string | null;
          readonly oidcInitiateLoginUrl: string | null;
          readonly oidcIssuer: string | null;
          readonly oidcUsePkce: string | null;
          readonly providerType: identityprovidertype;
          readonly samlAcsUrl: string | null;
          readonly samlMetadataUrl: string | null;
          readonly uuid: string;
        } | null;
        readonly loginType: login_type;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "OrgLoginMethods_loginMethods";
};
export type OrgLoginMethods_loginMethods$key = {
  readonly " $data"?: OrgLoginMethods_loginMethods$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgLoginMethods_loginMethods">;
};

import OrgLoginMethodsRefetchQuery_graphql from './OrgLoginMethodsRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loginType",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "providerType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "samlAcsUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "samlMetadataUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oidcCallbackUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oidcInitiateLoginUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oidcClientId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oidcIssuer",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oidcUsePkce",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "axonConnectDomain",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": OrgLoginMethodsRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "OrgLoginMethods_loginMethods",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "LoginOverrideCount",
      "kind": "LinkedField",
      "name": "loginOverrideCounts",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IdentityProviderConfigurationConnection",
      "kind": "LinkedField",
      "name": "identityProviderConfigurations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IdentityProviderConfigurationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentityProviderConfiguration",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v2/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/),
                (v11/*: any*/),
                (v12/*: any*/),
                (v13/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orgDefault",
          "value": true
        }
      ],
      "concreteType": "LoginTypesConnection",
      "kind": "LinkedField",
      "name": "loginTypes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LoginTypesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LoginTypes",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "authEnabled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IdentityProviderConfiguration",
                  "kind": "LinkedField",
                  "name": "identityProviderConfiguration",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v3/*: any*/),
                    (v4/*: any*/),
                    (v5/*: any*/),
                    (v6/*: any*/),
                    (v7/*: any*/),
                    (v8/*: any*/),
                    (v9/*: any*/),
                    (v10/*: any*/),
                    (v11/*: any*/),
                    (v12/*: any*/),
                    (v13/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "loginTypes(orgDefault:true)"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "0a2a3fa56cfb1ab738e339db42367a4d";

export default node;
